window.Third = {

	addressMarkers: [],
	popupMap: null,
	editableSticky: true,
	graph: {},

	initTips : function (){
        $("[tip_type=nbcontacts]").each(function () {
            var relatedId = $(this).attr('tip_relid');
            $(this).qtip({
                style: {
                    classes: 'qtip-custom qtip-rich',
                    def: false,
					tip: {
						corner: false
					}
                },
                position: {
                    viewport: true,
                    my: 'right top',
                    at: 'left center'
                },
                show: {
                    event: 'mouseover'
                },
                hide: {
                    event: 'mouseout',
                    fixed: true,
                    delay: 100
                },
                content: {
                    text: MyWindow.getLoader(),

                    ajax: {
                        type: 'GET',
                        url: './?_f=thirds',
                        data: {
                            action: 'popContacts',
                            thirdid: relatedId
                        },
                        once: true
                    }
                }
            });
        });
	},

	loadAgendaTab : function(startTime, endTime, days, view, forceLocation){
		if($('#third-fullcalendar table').length == 0) {
			setTimeout(function() {
				$('#calendar').fullCalendar('destroy');
				MyFacture.customForm();
				Agenda.initCalendar(startTime, endTime, days, view, forceLocation);
			}, 500);
		}
	},

	prepareEventsTab: function () {
		$('#third-fullcalendar #calendar').fullCalendar('render');
		$('#agendaTask .nano').height($('#calendar').height() - 30);
	},

	initTimeline: function (thirdid, tsStart) {
		$('#third_timeline').timeline({
			url: './?_f=third',
			ajaxParams: {thirdid: thirdid, action: 'timeline'},
			start: new Date(tsStart * 1000),
			monthWidth: 515
		});
	},


	slideStat: function (step) {
		$('.totalContent .slide').animate({'left': -(step * 280)}, 300);
	},

	setMainContact: function (contactId) {
		$('#contact_' + contactId).next().fadeOut(50).fadeIn(50);
		var thirdId = $('input[name=thirdid]').val();
		var thirdType = $('input[name=thirdtype]').val();

		var options = {action: "setMainContact", thirdid: thirdId, thirdtype: thirdType, contactid: contactId};

		MyFacture.post(
				"third",
				options,
				function (data) {
					if (data.maincontact != undefined) {
                        $('.contact-card:not(#contact-' + data.maincontact.newcontact + ')').find('.main-star .fa').removeClass('icon-star-full-fillout').addClass('icon-star');
                        $('#contact-' + data.maincontact.newcontact).find('.main-star .fa').removeClass('icon-star').addClass('icon-star-full-fillout');
					}
				}, "json");
	},

	setMainAddress: function (addressId) {
		$('#address_' + addressId).next().fadeOut(50).fadeIn(50);
		var thirdId = $('input[name=thirdid]').val();
		var thirdType = $('input[name=thirdtype]').val();

		var options = {action: "setMainAddress", thirdid: thirdId, thirdtype: thirdType, addrid: addressId};
		MyFacture.post("third", options, function (data) {
			if (data.mainaddress != undefined) {
				$('.addressBlock:not(#address_' + data.mainaddress.newaddress + ')').find('.main-star .fa').removeClass('icon-star-full').addClass('icon-star');
				$('#address_' + data.mainaddress.newaddress).find('.main-star .fa').removeClass('icon-star').addClass('icon-star-full');
			}
		}, "json");
	},

	editContact: function (contactId, thirdId) {
		var formId = "thirdContactForm";
		var thirdType = $('input[name=thirdtype]').val();

		var title = Loc.g('Modifier un contact');
		if (contactId === undefined) {
			title = Loc.g("loc");
			contactId = '';
		}

		if (thirdId === undefined) {
			thirdId = $('input[name=thirdid]').val();
		}

		var options = {
			title: title,
			buttons:
					[
						{text: Loc.g("Annuler"), click: function () {
								$(this).dialog("close");
							}},
                        {text: Loc.g("Enregistrer"), click: function () {
                            $("#" + formId).submit();
                        }},
					],
			width: 450,
			callback: function () {
				var options = {success: function (data) {
						var formIsOk = MyForm.processJson(data, formId);
						if (formIsOk) {
							MyWindow.close();
							Utils.reload();
						}
					},
					dataType: "json",
					data: {thirdid: thirdId, thirdtype: thirdType, action: "recordContact"}
				};

				MyForm.prepare(formId, "third", options, true);
				MyFacture.initEvent();
			}
		};

		MyWindow.load("third", {action: "contactForm", thirdid: thirdId, thirdtype: thirdType, contactid: contactId}, options);
	},

	deletePeoplePicture: function () {
		$('#peoplePicture img').fadeOut().attr('src', 'ressources/logged/img/common/people.jpg').fadeIn();
		$('#peoplePicture input').val('');
		$('#peoplePicture #deletePeoplePicture').hide();
	},

	updateMainAddressCallback: function (data) {
		if (data.mainaddress === undefined) {
			return;
		}
		$("#address_" + data.mainaddress.oldaddress + " a.main-star i.icon-star-full").removeClass("icon-star-full").addClass("icon-star");
		$("#address_" + data.mainaddress.newaddress + " a.main-star i.icon-star").removeClass("icon-star").addClass("icon-star-full");
	},

	updateMainDelivAddressCallback: function (data) {
		if (data.maindelivaddress === undefined) {
			return;
		}
		$("#address_" + data.maindelivaddress.oldaddress + " a.main-delivstar i.fa-paper-plane").removeClass("fa-paper-plane").addClass("fa-paper-plane-o");
		$("#address_" + data.maindelivaddress.newaddress + " a.main-delivstar i.fa-paper-plane-o").removeClass("fa-paper-plane-o").addClass("fa-paper-plane");
	},

	deleteContact: function (id) {
		if (!Utils.exists("contact_" + id)) {
			return false;
		}

		var thirdId = $('input[name=thirdid]').val();

		var datas = {'action': "deleteContact", 'contactid': id, 'thirdid': thirdId};
		MyFacture.post("third", datas, function (data) {
			Third.deleteContactCallback(data);
		}, "json");
		return true;
	},

	deleteContactCallback: function (data) {
		if (data.contactid && Utils.exists("contact_" + data.contactid)) {
			$("#contact_" + data.contactid).fadeOut('fast', function () {
				if (data.mainContactid && Utils.exists("contact_" + data.mainContactid)) {
					$(".subHeader #contact_" + data.mainContactid).remove();
					$("#contact_" + data.mainContactid + " a.icon-star").removeClass("icon-star").addClass("icon-star-full");
					if ($(".subHeader .contacts .smallPeopleCard").length == 0) {
						$('.mainHeader .contacts a.moreLink').hide();
					}
				}
				$(this).remove();
			});
		}

		// If we are back in creations limits
		var maxcontacts = $('input[name=maxcontacts]').val();
		if ($('.peopleCard').length >= maxcontacts) {
			$('a#newContact:visible').addClass("hidden");
		} else {
			$('a#newContact:hidden').removeClass("hidden");
			MyFacture.customForm($('.btn-default'));
		}
	},

	checkRiskAwareness: function () {
		$("#risk-awareness").prop("checked") ?
			$(".ui-dialog-buttonset .btn-danger").removeClass("btn-disabled")
			:
			$(".ui-dialog-buttonset .btn-danger").addClass("btn-disabled");
	},

	harddelete: function(rowSelection, listingName){

		var options = {
			dialogClass : "white no-title",
			title		: Loc.g("Suppression définitive"),
			buttons		: [
                {
                    text	: Loc.g("Annuler mon action"),
                    'class'	: "btn btn-no-border",
                    click	: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text	: Loc.g("Supprimer les données"),
                    'class'	: "btn btn-danger btn-disabled",
                    click	: function () {
                        var self = $(this);
                        var datas = {
                            action			: "harddeleteprocess",
                            rowSelection	: rowSelection,
                        };
                        if ($("#risk-awareness").prop("checked")) {
                            MyFacture.post("thirds", datas, function (data) {
                                self.dialog("close");
                                Push.success(Loc.g("La suppression des données est en cours et sera terminée dans quelques minutes."));
                                Utils.reload();
                            }, "json");
                        }
                    }
                }
			],
			width		: 800,
			callback	: function () {
				Qtip.init();
			}
		};

        var fileOpt = { action: "harddelete", rowSelection: rowSelection, listingName : listingName};
		MyWindow.load("thirds", fileOpt, options);

	},

	deletethirdsGroupAction: function(rowSelection, listingName){

		var thirdtype = $("input[name='thirdtype']").val();

		if (thirdtype === undefined && listingName !== undefined) {
		    switch (listingName.toLowerCase()) {
		        case 'prospects':
		        case 'prospect':
		            thirdtype = 'prospect';
		            break;
		        case 'suppliers':
		        case 'supplier':
		            thirdtype = 'supplier';
		            break;
		        case 'clients':
		        case 'client':
		            thirdtype = 'client';
		            break;
		        case 'companies':
		            thirdtype = 'company';
		            break;
				case 'individuals':
				case 'individual':
		            thirdtype = 'person';
		            break;
		    }
		}

		let msg = "";
		let title = "";
		let btnAll = "";
		let btnOne = "";

		if (listingName == 'individuals') {
			title = Loc.g("Supprimer les particuliers");
			msg = Loc.g("Vous allez supprimer ces particuliers, cette action est irreversible.");
			msg += "<br />"+Loc.g("Vous conserverez cependant tous les documents relatifs à ces particuliers.");
			btnAll = Loc.g("Supprimer les particuliers");
		} else {
			title = Loc.g("Supprimer les sociétés");
			msg = Loc.g("Vous allez supprimer ces sociétés, cette action est irreversible.");
			msg += "<br />"+Loc.g("Vous conserverez cependant tous les documents relatifs à ces sociétés.");
			msg += "<br />" + Loc.g("Vous avez la possibilité de conserver les contacts ou non.");
			btnAll = Loc.g("Supprimer les sociétés et leurs contacts");
			btnOne = Loc.g("Supprimer uniquement les sociétés");
		}

		msg += "<br /><br />"+Loc.g("Choisissez une action pour continuer");

		var options = {
			type        : "warning",
			resizable   : false,
			noclose     : true,
			width       : 700,
			title       : title,
			buttons: [
				{
					text: Loc.g("Annuler"),
					'class': "btn btn-default",
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: btnAll,
					'class': "btn btn-primary",
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('thirds', {action: "deleteThirds", thirdtype:thirdtype, rowSelection: rowSelection, keepContacts:'N'}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};
		if (btnOne) {
			options.buttons.push({
				text: btnOne,
				'class': "btn btn-primary",
				click: function () {
					MyWindow.wait('alertWindow');
					MyFacture.post('thirds', {action: "deleteThirds", thirdtype:thirdtype, rowSelection: rowSelection, keepContacts:'Y'}, function (data) {
						Utils.reload();
					}, "json");
				}
			});
		}

		var showDeleteForm = function(){
			MyWindow.alert(msg, options)
		};

		if(Third.hasDocLinked(rowSelection)){
			MyWindow.alert(Loc.g("Il existe des documents rattachés à au moins un élément sélectionné, êtes-vous sûr de vouloir continuer?"), {
				resizable	: false,
				noclose		: true,
				title		: $('input[name=thirdtype]').val() !== 'prospect' ? Loc.g("Des documents sont rattachés aux sociétés sélectionnées") : Loc.g("Des documents sont rattachés aux prospects sélectionnés"),
				type		: "warning",
				width		: 450,
				buttons		: [
					{
						text : Loc.g("Non"),
						click : function(){
						$(this).dialog("close");
						}
					},
					{
						text : Loc.g("Oui"),
						click : function(){
							showDeleteForm();
						}
					}
				]
			});
		} else {
			showDeleteForm();
		}

	},

	deleteThird: function (thirdid, deletePeople, thirdtype) {
		var deletePeople = deletePeople == undefined ? 'Y' : deletePeople;

		var msg = Loc.g("Vous allez supprimer cette société, cette action est irreversible.");
		msg += "<br />"+Loc.g("Vous conserverez cependant tous les documents relatifs à ce client.");
		msg += "<br />"+Loc.g("Vous avez la possibilité de conserver les contacts ou non.");
		msg += "<br /><br />"+Loc.g("Etes-vous sûr de vouloir continuer ?");

		var options = {
			dialogClass: 'white',
			resizable: false,
			title: Loc.g("Supprimer la société"),
			width : 700,
			buttons: [
                {
					text: Loc.g("Supprimer uniquement la société"),
					class	: 'btn btn-default',
					click: function () {
					    MyWindow.wait('alertWindow');
					    $.ajax({
					        type: "POST",
					        url: MyFacture.buildUrl('third'),
					        data: {action: "deleteThird", thirdid: thirdid, keepContacts : 'Y'},
					        success: function (data) {
					            if (data.success) {
					                Utils.relocate(data.returnUrl);
					            }
					        },
					        error: function(error){
					            MyWindow.awake('alertWindow');
					        },
					        dataType: 'json'
					    });
					}
				}
			]
		};

		if(deletePeople == 'Y'){
			options.buttons.push({
				text: Loc.g("Supprimer la société et ses contacts"),
				class	: 'btn btn-primary',
                click: function () {
                    MyWindow.wait('alertWindow');
                    $.ajax({
                        type: "POST",
                        url: MyFacture.buildUrl('third'),
                        data: {action: "deleteThird", thirdid: thirdid, keepContacts : 'N'},
                        success: function (data) {
                            if (data.success) {
                                Utils.relocate(data.returnUrl);
                            }
                        },
                        error: function(error){
                            MyWindow.awake('alertWindow');
                        },
                        dataType: 'json'
                    });
                }
            });
		}

		var showDeleteForm = function(){
			MyWindow.alert(msg, options);
		}

		if(Third.hasDocLinked(thirdid, thirdtype)){
			MyWindow.alert(
				Loc.g("Il existe des documents rattachés à cette société, êtes-vous sûr de vouloir continuer?"), {
				resizable	: false,
				title		: Loc.g("Des documents sont rattachés à cette société"),
				dialogClass: 'white',
				width		: MyWindow.medium,
				buttons		: [
                    {text : Loc.g("Non"),
                        click : function(){
                            $(this).dialog("close");
                        }},
                    {text : Loc.g("Oui"),
					click : function(){
						showDeleteForm();
					}}
				]
			});
		} else {
			showDeleteForm();
		}

	},

	hasDocLinked : function(thirdid, thirdtype){

		var hasDocLinked = false;

		if (thirdtype == undefined) {
			thirdtype = $('#thirdtype').length > 0 ? $('#thirdtype').val() : 'third';
		}

		var dataArray = {
			action		: 'hasDocLinked',
			type 		: 'third',
			thirdtype	: thirdtype,
			thirdid		: thirdid,
		};

		$.ajax({
			url 		: '/?_f=third',
			type 		: 'POST',
			data 		: dataArray,
			dataType 	: 'json',
			async		: false,
			success		: function(data){
				hasDocLinked = data.hasDocLinked
			}
		});

		return hasDocLinked;

	},

	edit: function (thirdId) {

		if($('#hasSellsySynchroEnabled').length && $('#hasSellsySynchroEnabled').val() == 'Y'){
			MyWindow.alert('SellsyADMIN : Edition / Supression impossible, ce client est synchronisé avec une CORP ', {type : 'error'});
			return;
		}

		var formId = "thirdForm";
		var thirdType = $('input[name=thirdtype]').val();

		if (thirdId === undefined) {
			thirdId = $('input[name=thirdid]').val();
		}

		var options = {
			title: Loc.g("Modifier la société"),
			dialogClass: "white",
			buttons: [
				{
					text	: Loc.g("Annuler"),
					'class'	: 'btn btn-default',
					click	: function () {
								$(this).dialog("close")
							}
				},
                {
					text	: Loc.g("Enregistrer"),
					'class'	: 'btn btn-primary',
					click	: function () {
                    			$("#" + formId).submit();
							}
				},
			],
			width: 1200,
			height: 800,
			callback: function () {
				var options = {success: function (data) {
						var formIsOk = MyForm.processJson(data, formId);
						if (formIsOk) {
							var listingToCheck = 'thirdsListing';
							switch (thirdType) {
								case "supplier":
									listingToCheck = 'suppliersListing';
									break;
								case "prospect":
									listingToCheck = 'prospectsListing';
									break;
							}

							if ($("#" + listingToCheck + "_container").length > 0) {
								Listing.update(listingToCheck);
							} else {
								if (data.valueCampaignUpdated == 'Y') {
									Utils.relocate('?_f=third&thirdid=' + data.thirdId + '&campaign=1');
								} else {
									Utils.reload();
								}
							}

							MyWindow.close();
						}
					},
					dataType: "json",
					data: {thirdid: thirdId, thirdtype: thirdType, action: 'recordThird'}
				};

				MyForm.prepare(formId, "third", options, true);
				MyFacture.customForm("#" + formId);
				Qtip.init();
			}
		};
		MyWindow.load("third", {action: "thirdForm", thirdid: thirdId, thirdtype: thirdType}, options);
	},

	create: function (type, docallback, event, prefill, hasProspectionPlugin, inputsValues) {
		docallback = docallback == undefined ? "" : docallback;
		event = event == undefined ? "" : event;
        hasProspectionPlugin = hasProspectionPlugin == undefined ? "Y" : hasProspectionPlugin;

		if (docallback === "injectThirdInFastPurchase" || docallback === "injectThirdInFastExpense" || docallback === "injectThirdInBookForm") {
			var inputTarget = "#" + $(event.currentTarget).attr("inputTarget");
		}

		var title = Loc.g("Créer un client");

		switch (type) {
			case "prospect":
				title = Loc.g('Créer un prospect');
				break;
			case "supplier":
				title = Loc.g('Créer un fournisseur');
				break;
		}

		var options = {
			title: title,
			dialogClass: "white",
			width: 1280,
			height: 800,
			buttons: [
				{
					text: Loc.g("Annuler"),
					'class' : 'btn-default',
					click: function () {
						MyWindow.close('thirdFormCreateWindow');
					}
				},
                {
                	text: Loc.g("Enregistrer"),
                    'class' : 'btn-primary',
					click: function () {
                    	$("#thirdFormCreate").submit();
                	}
                }
			],

			callback: function () {

                if ($("#third-accounting-bloc").length) {
					Third.generateAuxiliaryAccountCode("#corp_name",
						"#thirdcontact_name", '#corp_auxCode', type, "#isPerson");
                }

				if ($('#relationType').val() === "prospect") {

					// Store popup buttons in array for manipulation
					var callbackButtons = MyWindow.getOption('buttons', 'thirdFormCreateWindow');

					// Add buttons
					if (document.getElementById("saveAvailableEstimate").value === "Y" && document.getElementById('isSellsyCorp').value === "N"){
						callbackButtons.splice(1,0,
							{
								text 	: Loc.g("Enregistrer et créer un devis"),
                                'class' : 'btn btn-primary',
								click 	: function () {
									$("#invoicing_createestimateForProspect").val("Y");
									$("#thirdFormCreate").submit();
								}
							}
						);
					}
					if ($("#saveAvailableProspection").val() == "Y" && hasProspectionPlugin == 'Y' ){
						callbackButtons.splice(1,0,
							{
								text 	: Loc.g("Enregistrer et créer une opportunité"),
								'class' : 'btn btn-primary',
								click 	: function () {
									$("#createOpportunityForProspect").val("Y");
									$("#thirdFormCreate").submit();
								}
							}
						);
					}

					// Overload popup buttons
                    MyWindow.addOption('buttons',callbackButtons,'thirdFormCreateWindow');

				}

				var options = {
					beforeSend : function(){
						MyWindow.wait('thirdFormCreateWindow');
					},
					success: function (data) {
                        /**
                         * For disable redirect, we need to set redirect at null|undefined before data is process in MF
                         */
                        if (docallback === 'noRedirect') {
                            data.redirect = null;
                        }
						var formIsOk = MyForm.processJson(data, 'thirdFormCreate');
						if (formIsOk) {

							if (data.thirdAlreayExist !== undefined && data.thirdAlreayExist == "Y") {
								var options = {
									type: "warning",
									resizable: false,
									noclose: true,
									title: Loc.g("Information Sellsy"),
									buttons:
										[
											{
												text: Loc.g("Annuler"),
												'class' : 'btn btn-default',
												click: function () {
													$(this).dialog("close");
												}
											},
											{
												text: Loc.g("Créer"),
                                                'class' : 'btn btn-primary',
												click: function () {
													$(this).dialog("close");
													$('#thirdFormCreate #checkDuplicate').val('N');
													$('#thirdFormCreate').submit();
												}
											},
										]
								};

								var msg = Loc.g("Il existe déjà une ou plusieurs sociétés avec ce nom, êtes vous sur de vouloir la re-créer ?");
								MyWindow.alert(msg, options);

							} else {

								switch (docallback) {

									case "injectThirdInBookForm" :
									case "injectThirdInFastExpense" :
									case "injectThirdInFastPurchase" :

										MyWindow.close('thirdFormCreateWindow');
										TokenInput.update(inputTarget, data.toInject);
										break;

                                    case "noRedirect":
                                        EventBus.emit('third:created', data);
                                        MyWindow.close('thirdFormCreateWindow');
                                        break;

									default :
										window.location.href = data.redirect;
										MyWindow.close('thirdFormCreateWindow');
										break;
								}

							}

                        }
						MyWindow.awake('thirdFormCreateWindow');
					},
					dataType: "json",
					data: {thirdtype: type, action: 'recordThirdFormCreate', docallback: docallback}
				};

				MyForm.prepare("thirdFormCreate", "third", options, true);
				MyFacture.customForm("#thirdFormCreate");
                Qtip.init();

                //Add company searchForm
                window.CompanySearch.getComponentCompanySearch('#third-companysearch-form', 'create');
                $('#corp_name').focus();
                if (inputsValues && Object.keys(inputsValues).length) {
                    _.forEach(inputsValues, (value, inputId) => {
                        if (document.getElementById(inputId)) {
                            document.getElementById(inputId).value = value;
                        }
                    })
                }
			}
		};

		MyWindow.load("third", {action: "thirdFormCreate", thirdtype: type}, options, true, 'thirdFormCreateWindow');
	},

	generateAuxiliaryAccountCode: function (idInputCorp, idInputPerson, idInputAux, type, idCheckIsPerson) {
		var name = '';
		$(`${ idInputCorp }, ${ idInputPerson }`).on('input', _.debounce(function() {
			//If Particulier not checked we set name from inputCorpName else from inputPersonName
			name = $(idCheckIsPerson).prop("checked") ? $(idInputPerson).val() : $(idInputCorp).val();

			if (name != '' && (type == 'client' || type == 'supplier')) {
				var query = $.ajax({
					type: "GET",
					url: '/auxiliarycode/getnextcode',
					data: {
						thirdname:	name,
						thirdtype:	type,
					},
					success: function (data) {
						$(idInputAux).val(data.auxCode);
					},
					dataType: 'json'
				});
			}
		}, 500));
	},


	switchThirdType: function () {

		var field = null;
		if ($("#third_isPerson").prop('checked')) {
			$("#ThirdCorpFields").fadeOut(function () {
				$("#ThirdUserFields").fadeIn();
				$("#ThirdSendDiv").fadeIn(function () {
					MyFacture.customForm("#ThirdSendDiv");
				});
			});
		} else {
			$("#third_send").prop("checked", false);

			$("#ThirdSendDiv").fadeOut();
			$("#ThirdUserFields").fadeOut(function () {
				$("#ThirdCorpFields").fadeIn();
			});
		}

	},

	switchType: function () {

		var isPerson = $("#isPerson").prop("checked");
		var contactTitle = "formTitleCorpContact";
		if (isPerson) {
			contactTitle = "formTitlePersonContact";
		}

		if ($("#thirdFormContactTitle").length > 0) {
			$("#thirdFormContactTitle").find('span').html($("#" + contactTitle).html());
		}

		var toFade = {
			thirdFormCorpDiv	: $('.thirdFormCorpDiv'),
			peopleFormContainer : $('#peopleFormContainer')
		};

		if(isPerson){
			toFade.thirdFormCorpDiv.fadeOut();

		}else{
			toFade.thirdFormCorpDiv.fadeIn();
		}

		var field = null;
		var root = $('.newThirdForm');

		if(root.find("input[name=third_isPerson]").prop('checked')){
			root.find("#thirdCorpFields").fadeOut(function(){
				root.find("#thirdUserFields").fadeIn('fast',function(){
					MyFacture.customForm('#thirdUserFields');
					Qtip.init();
				});
				root.find("#thirdSendDiv").fadeIn(function(){
					MyFacture.customForm('#thirdSendDiv');
				});
			});

		} else {
			root.find("#third_send").prop("checked", false);

			root.find("#thirdSendDiv").fadeOut();
			root.find("#thirdUserFields").fadeOut(function(){
				root.find("#thirdCorpFields").fadeIn();
			});

		}

	},

	switchTypeEdit: function () {

		var isPerson = $("#third_isPerson").prop("checked");
		if (isPerson === "checked") {
			$('.thirdFormCorpDiv').hide();
			$('.thirdFormPersonDiv').show();
		} else {
			$('.thirdFormCorpDiv').show();
			$('.thirdFormPersonDiv').hide();
		}
		MyFacture.customForm();
	},

	toggleFieldSetForm: function (me) {

		var content = me.closest('fieldset').find('.contentFieldset');

		if (content.hasClass('hidden')) {
			content.removeClass('hidden');
			me.html('[' + Loc.g("Masquer") + "]");
		} else {
			content.addClass('hidden');
			me.html('[' + Loc.g("Ajouter") + "]");
		}
		MyFacture.customForm("#thirdFormCreate");

	},

	toggleDocumentMenu: function () {
		$('#docCreation').slideToggle();

	},

	sendContactPwd: function (contactId, thirdId) {

		var msg = Loc.g('Vous allez renvoyer un nouveau mot de passe à ce client.') + '<br /><br />' + Loc.g('Son ancien mot de passe sera désactivé.');
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Renvoi de mot de passe"),
			type : 'warning',
			buttons: [
                {text: Loc.g("Annuler"), click: function () {
                    $(this).dialog("close");
                }},
                {text: Loc.g("Valider"),
					click: function () {
						Third.processSendContactPwd(contactId, $(this), thirdId);
					}}
			]
		};

		MyWindow.alert(msg, options);

	},

	openThirdAccess: function (contactId, thirdId) {
		var thirdId = thirdId == undefined ? $('input[name=thirdid]').val() : thirdId;

		var options = {action: "sendContactPassword", thirdid: thirdId, contactid: contactId};
		MyFacture.post("third", options, function (data) {

			if (data.result.type == 'error') {
				Nylas.connectError();
			} else {
				Utils.reload();
			}
		}, "json");
	},

	closeThirdAccess: function (contactId, relatedThirdId) {
		var msg = Loc.g('Vous allez supprimer l‘accès à l‘espace client de ce contact.') + '<br /><br />' + Loc.g('Continuer ?');
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Fermeture de l‘espace client"),
			type : 'warning',
			buttons: [
                {text: Loc.g("Annuler"), click: function () {
                    $(this).dialog("close");
                }},
                {text: Loc.g("Valider"),
				click: function () {
                		var me = $(this);
						var thirdId = relatedThirdId == undefined ? $('input[name=thirdid]').val() : relatedThirdId;

						var options = {action: "closeThirdAccess", thirdid: thirdId, contactid: contactId};

						MyFacture.post("third", options, function (data) {

							Utils.reload();
							me.dialog("close");
						}, "json");

					}}
			]
		};

		MyWindow.alert(msg, options);

	},

	processSendContactPwd: function (contactId, me, thirdId) {

		if(typeof thirdId === 'undefined'){
			thirdId = $('input[name=thirdid]').val();
		}

		var options = {action: "sendContactPassword", thirdid: thirdId, contactid: contactId};
		MyFacture.post("third", options, function (data) {

			if (data.result.type == 'error') {
				me.dialog("close");
				Nylas.connectError();
			} else {
				Utils.reload();
				me.dialog("close");
			}

		}, "json");

	},

	newDocForProspect: function (thirdid) {
		Third.newDoc(thirdid, 'prospect');
	},

	newOppForProspect: function (thirdid) {
		Opportunity.addOpportunity('', thirdid);
	},

	newDoc: function (thirdid, thirdtype, doclinktype, doclinkid, doclinkcontext) {

		doclinktype		= doclinktype == undefined ? '' : doclinktype;
		doclinkcontext	= doclinkcontext == undefined ? '' : doclinkcontext;
		doclinkid		= doclinkid == undefined ? '' : doclinkid;
		thirdtype		= thirdtype == undefined ? '' : thirdtype;

		var useEcotaxe	= $("#useEcotaxe").val();

		var options = {
			title: Loc.g("Nouveau document"),
			dialogClass: "white",
			buttons: [
                {
                	text: Loc.g("Annuler"),
					click: function () {
                    	$(this).dialog("close");
                	}
                },
                {
                	text: Loc.g("Créer le document"),
					click: function () {
						$('#thirdNewDoc').submit();
					}
                }
			],
            width: MyWindow.medium,
            dialogClass: "white",
			callback: function () {
				Third.prepareDocCallback(thirdid, thirdtype, doclinktype, doclinkid, doclinkcontext);
			}
		};
		MyWindow.load("third", {action: "newDoc", thirdid: thirdid, doclinktype: doclinktype, doclinkid: doclinkid, doclinkcontext: doclinkcontext, thirdtype: thirdtype, useEcotaxe: useEcotaxe}, options);
	},

	prepareDocCallback: function (thirdid, thirdtype, doclinktype, doclinkid, doclinkcontext) {
		var formId = "thirdNewDoc";
		var options = {success: function (data) {
				Utils.relocate(data.url);
			}, dataType: "json"};

		var data = {
			action: 'newDocRecord',
			thirdid: thirdid,
			thirdtype: thirdtype,
			doclinktype: doclinktype,
			doclinkid: doclinkid,
			doclinkcontext: doclinkcontext
		};
		MyForm.prepare(formId, "third&" + $.param(data), options, true);
		MyFacture.initEvent();
	},

	loadPieceForForm : function(formID, relationType, linkedType, options, more){

		options = !_.isUndefined(options) ? options : {};

		return $.ajax({
			url			: '/?_f=third',
			dataType	: 'html',
			data		: {
				action			: 'formForRelated',
				relationType	: relationType,
				linkedType		: linkedType,
				more			: more
			},
			beforeSend : function(){

				$('.newThirdForm:not(#'+formID+')').empty();
				MyWindow.wait();

				if(_.isFunction(options.beforeSend)){
					options.beforeSend();
				}

			},
			success		: function(data) {

				$('#' + formID).html(data).slideDown(200, function(){
					MyFacture.customForm('#'+formID);
				});

				if(_.isFunction(options.success)){
					options.success(data);
                }

                if ($("#accounting_bloc").length) {
                    Third.generateAuxiliaryAccountCode("#corp_name", "#thirdcontact_name", "#corp_auxCode", relationType, "#isPerson")
                }

                // Add company searchForm
                window.CompanySearch.getComponentCompanySearch('#third-companysearch-form', 'create');

			},
			complete : function(){
				MyWindow.awake();
            }
		});

	},

	toggleStats: function () {

		var $statFilter = $('#statFilter');

		var toAnimate = 'right';
		var divHeight = $statFilter.width() + 12 + 25;
		var actualPos = parseFloat($statFilter.css(toAnimate), 10);

		var newPosition = 0;
		if (actualPos < 0) {
			newPosition = actualPos + divHeight;
		} else {
			newPosition = actualPos - divHeight;
		}

		$statFilter.animate({right: newPosition});

	},

	statGraph: function () {

		var object			= Persistent.get("graphics_data", true, true);
		var displayGraphics = Persistent.get("graphics_data_display", false);

		for (var i in object.datas) {
			for (var j in object.datas[i].data) {
				object.datas[i].data[j] = parseFloat(object.datas[i].data[j], 10);
			}
		}

		var params = {
			chart: {
				renderTo: 'graphics_display',
				height: 202,
				type: 'line',
				backgroundColor: "transparent",
				zoomType: 'x',
			},
			colors: ['#2372b4', '#b2231f', '#2fb500', '#fe8c05'],
			title: {
				text: Loc.g('Évolution de votre CA'),
				margin: 5
			},
			xAxis: {
				title: {
					text: ''
				},
				labels: {
					style: {
						fontSize: '7px'
					},
					step: object.head.length >= 16 ? Math.ceil(object.head.length / 16) : 1
				},
				categories: object.head
			},
			yAxis: {
				labels: {
					style: {
						fontSize: '9px'
					}
				},
				title: {
					text: ''
				}
			},
			legend: {
				enabled: true,
				layout: 'horizontal',
				align: 'center',
				verticalAlign: 'bottom',
				width: 600,
				x: 0
			},
			credits: {
				enabled: false
			},
			series: object.datas ? object.datas : '',
			tooltip: {
				formatter: function () {
					var numformat 	= NumberFormat.loadFromInputs('num_');
					var hasCurrency = this.series.userOptions.hasCurrency;
					var method 		= (hasCurrency == undefined || hasCurrency == 'N') ? 'formatToDisplay' : 'formatToDisplayWithCurrency';

					return ""+ Loc.g("Période")+" : "+this.x +"<br/>"
						+this.series.name + " : "
						+NumberFormat[method](this.y, numformat);
				}
			},
			plotOptions: {
				line: {
					marker: {
						enabled: false,
						states: {
							hover: {
								enabled: true,
								symbol: 'circle',
								radius: 5,
								lineWidth: 1
							}
						}
					}
				}
			}
		};
		Third.graph = new Highcharts.Chart(params);
	},

	prepareFilterForm: function (type, gmaps) {
		var gmaps = gmaps == undefined ? 'N' : gmaps;
		var options = {
			success: function (data) {
				Third.processFilterForm(data, type);
				if (gmaps === 'Y') {
					ThirdMap.init();
					if (type == 'client' || type == 'prospect' || type == 'supplier') {
						ThirdMap.updateMap("#thirds_contentListing td[data-colname=thirdAddress]");
					} else {
						ThirdMap.updateMap("#" + type + "s_contentListing td[data-colname=address]");
					}
				}

			},
			dataType: "json",
			data	: {
				type	: type,
				action	: 'updateListing'
			}
		};

		MyForm.prepare(type+"sFilterForm", "thirds", options);

		var inputScoreMin = $('#'+type+'sListing_filter_minScore');
		var inputScoreMax = $('#'+type+'sListing_filter_maxScore');
		if (inputScoreMin.length && inputScoreMax.length) {
			var scoreMin = inputScoreMin.val() !== "" ? inputScoreMin.val() : 0;
			var scoreMax = inputScoreMax.val() !== "" ? inputScoreMax.val() : 100;

			$("#slider-score").slider({
				range: true,
				min: 0,
				max: 100,
				values: [scoreMin, scoreMax],
				slide: function( event, ui ) {
					$("#score").val(window.i18n.__(
						'%(min)d%% et %(max)d%%',
						{
							'min' : ui.values[0],
							'max' : ui.values[1]
						}
					));
				},

				stop: function( event, ui ) {
					inputScoreMin.val(ui.values[0]);
					inputScoreMax.val(ui.values[1]);
					Listing.update(type+'sListing');
				}
			});
			$("#score").val(window.i18n.__(
				'%(min)d%% et %(max)d%%',
				{
					'min' : $("#slider-score").slider("values", 0),
					'max' : $("#slider-score").slider("values", 1)
				}
			));
		}
		Listing.updateLocFilter(type+'sListing');

		if (gmaps === 'Y') {
			ThirdMap.init();
			if (type == 'client' || type == 'prospect' || type == 'supplier') {
				ThirdMap.updateMap("#thirds_contentListing td[data-colname=thirdAddress]");
			} else {
				ThirdMap.updateMap("#" + type + "s_contentListing td[data-colname=address]");
			}
		}

		var start = new Date().getTime();

		Listing.handleOrigin4Listing(type+'sListing');

		Third.qtipInit();

		var end = new Date().getTime();
		var time = end - start;

	},

	processFilterForm: function (data, type) {

		var metadatas = false;
		switch (type){
			case "client":
				metadatas = data.clients_metadatas
				break;
			case "prospect":
				metadatas = data.prospects_metadatas
				break;
			case "supplier":
				metadatas = data.suppliers_metadatas
				break;
		}

        Listing.refresh(type+"sListing", data, metadatas);
        if(ThirdMap.map) {
            ThirdMap.updateMap("#thirds_contentListing td[data-colname=address]");
        }
		Third.qtipInit();
	},

	qtipInit: function () {

		$('.contacts li', '#thirds_contentListing').each(function () {

			var $li		= $(this);
			var toQtip	= $('.contactname', $li);
			var $coords = $('.coords', $li);

			toQtip.qtip({
				style : {
					classes : 'custom-qtip mw-300',
					def		: false
				},
				position: {
					viewport: true,
					my : 'right center',
					at : 'left center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout',
					fixed: true,
					delay: 100
				},
				content: $coords.html()
			});
		});

	},

	updateState: function (rowSelection) {

		var options = {
			title: Loc.g("Archiver / désarchiver"),
			buttons: [
                {text: Loc.g("Annuler"), click: function () {
                    $(this).dialog("close");
                }},
                {text: Loc.g("Enregistrer"), "class":"btn btn-primary", click: function () {
						$("#updateStateForm").submit();
					}}
			],
			width: 500,
			callback: function () {

                var params = { 'action': 'updateStateRecord', 'thirds': rowSelection };

				var options = {
                    method: "POST",
					success: function (data) {

						MyWindow.close();

						var msg = "";

						if (data.modified.length > 0) {

							var res = "<div class='table' style='margin-top:6px;'><table>";
							for (var i in data.modified) {

								res += "<tr><td>" + data.modified[i].name + "</td></tr>";
							}
							res += "</table></div>";

                            msg = Loc.g("Les contacts suivants ont été") + ' ' + (data.state_activ === 'Y' ? Loc.g('désarchivés') : Loc.g('archivés')) + " : <br/>" + res;

						} else {
							msg = "<p class='alert alert-info'>" + Loc.g("Aucun élément n‘a été mis à jour.") + "</p>";
						}

						MyWindow.alert(
								msg,
								{
									title: Loc.g('Archiver / désarchiver'),
									type: 'info',
									buttons: [
										{text: Loc.g("Ok"), click: function () {
                                            $(this).dialog("close");
                                            $("#groupedActionContainer").hide();
                                            Utils.reload();
                                        }}
									],
								}
						);
					},
                    dataType: "json",
                    data: params
				};

				MyForm.prepare("updateStateForm", "thirds", options, true);
				MyFacture.customForm();

			}
		};
		MyWindow.load('thirds', {action: "updateStateForm"}, options);
    },

    transformThirdType: function (rowSelection, newThirdType) {

        var options = {
            title: Loc.g("Transformation en société"),
            buttons: [
                {
                    text: Loc.g("Annuler"), click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text: Loc.g("Enregistrer"), "class": "btn btn-primary", click: function () {
                        $("#transformThirdTypeForm").submit();
                    }
                }
            ],
            width: 500,
            callback:function() {

                var params  = { action: 'transformThirdTypeRecord', thirds: rowSelection, newThirdType: newThirdType };

                var options = {
                    success: function (data) {

                        MyWindow.close();
                    },
                    method: "POST",
                    dataType: "json",
                    data: params
                };

                MyForm.prepare("transformThirdTypeForm", "thirds", options, true);
                MyFacture.customForm();
            }
        };
        MyWindow.load('thirds', { action: "transformThirdTypeForm", rowSelection: rowSelection, newThirdType: newThirdType}, options);
    },

    transformOneThirdType: function(thirdid, newThirdType){
        var options = {
            type: "warning",
            resizable: false,
            noclose: true,
            title: Loc.g("Confirmation"),
            buttons: [
                {
                    text: Loc.g("Annuler"),
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text: Loc.g("Valider"),
                    click: function () {
                        // action
                        Third.transformOneThirdTypeRecord(thirdid, newThirdType);
                        $(this).dialog("close");
                    }
                }
            ]
        };
        MyWindow.alert(Loc.g('Voulez-vous vraiment transformer ce particulier en société ?'), options);
    },

    transformOneThirdTypeRecord: function(thirdid, newThirdType){

        var datas = {
            action: "transformOneThirdType",
            thirdid: thirdid,
            newThirdType: newThirdType
        };

        MyFacture.post("third", datas, function (data) {
            if(data.status == 'ok'){
                Push.success(Loc.g('Transformation effectuée.'), Loc.g('Transformation réussie'));
                Utils.reload();
            } else{
                Push.error(Loc.g('Erreur lors de la transformation, veuillez ré-essayer d‘ici quelque instants'), Loc.g('Transformation échouée'));
            }
        }, "json");
    },

	subscribeCampaignThirds: function (rowSelection, typeThird, listingname) {
		var options = {
            dialogClass: "white",
			title: Loc.g("Inscription aux campagnes"),
			buttons: [
                {text: Loc.g("Annuler"), click: function () {
                    $(this).dialog("close");
                }},
                {text: Loc.g("Enregistrer"), click: function () {
					var typeCampaign = $('#typeCampaign').val();
					var unsubscribeContact = $('#unsubscribeContact').val();
					MyFacture.post('thirds&action=campaignThirdsRecord', {thirds: rowSelection, typeCampaign: typeCampaign, unsubscribeContact : unsubscribeContact, state : 'N', typeThird : typeThird}, function (data) {
						if (data.success == 'true') {
							MyWindow.close();
							var msg = Loc.g("Les clients ont été inscrits aux campagnes");
							MyWindow.alert(
								msg,
								{
									title: Loc.g('Inscription aux campagnes'),
									type: 'info',
									buttons: [
										{text:
												Loc.g("Ok"), click: function () {
												$("#thirdsFilterForm").submit();
												$(this).dialog("close");
												Listing.update(listingname + "Listing");
												EventBus.emit("batchaction:callback");
											}
										}
									],
								}
							);
						} else {
							Push.error(Loc.g(data.error), Loc.g('Double opt-in activée'));
						}
					}, "json");
			}}
			],
			width: 600,
			callback: function () {}
		};
		MyWindow.load('thirds', {action: "campaignThirds", typeThird : typeThird, status : 'subscribe'}, options);
	},

	unsubscribeCampaignThirds: function (rowSelection, typeThird, listingname) {
		var options = {
            dialogClass: "white",
			title: Loc.g("Désinscription des campagnes"),
			buttons: [
                {
					text: Loc.g("Annuler"),
					click: function () {
                    	$(this).dialog("close");
					}
				},
                {
					text: Loc.g("Enregistrer"),
					click: function () {
						var typeCampaign = $('#typeCampaign').val();
						var unsubscribeContact = $('#unsubscribeContact').val();
						MyFacture.post('thirds&action=campaignThirdsRecord', {thirds: rowSelection, typeCampaign: typeCampaign, unsubscribeContact : unsubscribeContact, state : 'Y', typeThird : typeThird}, function (data) {
							if (data.success == 'true') {
								MyWindow.close();
								var msg = Loc.g("Les clients ont été désinscrits des campagnes");
								MyWindow.alert(
									msg,
									{
										title: Loc.g('Désinscription des campagnes'),
										type: 'info',
										buttons: [
											{
												text:
													Loc.g("Ok"), click: function () {
													$("#thirdsFilterForm").submit();
													$(this).dialog("close");
													Listing.update(listingname + "Listing");
													EventBus.emit('batchaction:callback');
												}
											}
										],
									}
								);
							} else {
								Push.error(Loc.g(data.error), Loc.g('Double opt-in activée'));
							}
						}, "json");
					}
				}
			],
			width: 600,
			callback: function () {}
		};
		MyWindow.load('thirds', {action: "campaignThirds", typeThird : typeThird, status : "unsubscribe"}, options);
	},

	singleUpdateState: function (id, newState) {

		var options = {
			dialogClass: "white",
			title: newState === "Y" ? Loc.g("Restaurer") : Loc.g("Archiver"),
			buttons: [
                {
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
				    }
				},
                {
					text: Loc.g("Valider"),
					click: function () {
						MyFacture.post('third&action=updateSingleStateRecord', {third: id, activ: newState}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			],
		};
		MyWindow.alert(newState === "Y" ? Loc.g("Voulez-vous restaurer cette société ?") + "<br>" + Loc.g("Vous pouvez restaurer une société ou un contact pour le rendre disponible dans les listes ou dans les résultats de recherche.") : Loc.g("Vous pouvez archiver une société ou un contact pour ne plus le faire apparaître dans les listes ou dans les résultats de recherche.")+ "<br>"+Loc.g("Vous pourrez à l'avenir le restaurer si besoin."), options);
	},

	getConsolidatedTrade: function (thirdid, thirdtype) {

		var options = {
			title: Loc.g('Télécharger l‘état du compte client'),
			width: 600,
			buttons: [
                {
                    text: Loc.g("Annuler"), click: function () {
                    $(this).dialog("close");
                }
                },
                {
					text: Loc.g("Télécharger"), click: function () {
						$("#thirdConsolidatedTradeForm").submit();
						$(this).dialog("close");
					}}
				],
			callback: function () {
				Third.preapreConsolidatedTrade();
			}
		};

		MyWindow.load("third", {action: "consolidatedTradeForm", thirdid: thirdid, thirdtype: thirdtype}, options);

	},

	preapreConsolidatedTrade: function () {

		var formId = "thirdConsolidatedTradeForm";
		var options = {success: function (data) {
				var formIsOk = MyForm.processJson(data, "thirdConsolidatedTradeForm");
				if (formIsOk) {
				}
			}, dataType: "json"};

		var data = {action: 'getThirdConsolidatedTrade'};
		MyForm.prepare(formId, "third&" + $.param(data), options, true);
		MyFacture.initEvent();

	},

	updateLogo : function(data){
		$('.logo').find('.avatar').fadeOut(300, function(){
			$(this).parent().empty().append('<span class="avatar avatar-big avatar-picture"><img src="'+data.file+'" /></span>');
		});
	},

	deleteLogo : function(thirdid){
		MyFacture.post('third',  {action : 'deleteLogo', thirdid : thirdid}, function(datajson){
			$('.logo').find('.avatar').fadeOut(300, function(){
				$(this).parent().empty().append('<span class="avatar avatar-big">'+datajson.picture.value+'</span>');
			});
		}, 'json');
	},

    transformThird: function (toThirdType, thirdid, sourceid, relocate, reload = false) {
        relocate = typeof relocate !== 'undefined' ? relocate : '';
        var title = toThirdType == 'prospect' ? Loc.g("Transformer le client") : Loc.g("Transformer le prospect");
        var options = {
			title: title,
			dialogClass: "white",
            buttons: [
                {
                    text: Loc.g("Annuler"),
                    click: function () {
                        MyWindow.close();
                    }
                },
                {
                    text: Loc.g("Enregistrer"),
                    click: function () {
                        $("#transfoThird").submit();
                    }
                }
            ],
            width: 600,
            callback: function () {
                Qtip.init();
                var formOptions = {
                    data: {
                        action: 'transformToThird',
                        toThirdType: toThirdType
                    },
                    success: function (data) {
                        var formIsOk = MyForm.processJson(data, "transfoThird");

                        if (formIsOk) {
                            MyWindow.close();
                            if (data.error){
                                Push.error(Loc.g('Vous ne pouvez pas effectuer cette transformation car il existe des éléments liés à cette fiche uniquement disponibles sur les fiches clients (ex : factures, règlement)'), Loc.g('Erreur lors de la transformation'));
                            }else{
                                if (relocate != '') {

                                    var depositOK = relocate.search("deposit");
                                    if (depositOK === -1) {
										MyFacture.relocate(relocate);
                                    }
                                    else {
                                        var newLocation = window.location.href;
                                        newLocation = newLocation.replace(new RegExp('&alert=([^&]*)', 'g'), '');
                                        window.location.href = newLocation + '&deposit=open';
                                    }

                                }
                                else {
									if(reload){
										window.location.reload();
									}else{
										MyFacture.relocate("third&thirdid=" + thirdid + "&thirdtype=" + toThirdType);
									}
                                }
                            }
                        }
                    },
                    dataType: "json"
                };

                MyForm.prepare('transfoThird', "third", formOptions, true);
            }
        };

        MyWindow.load("third", { action: "checkTransfoThird", thirdid: thirdid, sourceid: sourceid, tothirdtype: toThirdType }, options);
    },

	switchTypeTransfo: function(){

		var isPerson = $("#isPerson").attr("checked");
		var toSwitch = new Array(".thirdFormCorpDiv");

		for(var i=0; i<toSwitch.length; i++){
			if(isPerson)
				$(toSwitch[i]).fadeOut();
			else
				$(toSwitch[i]).fadeIn();
		}

	},

	toggleMap: function(){
		MyFacture.post('thirds&action=toggleMap', {}, function (data) {
			Utils.reload();
		}, "json");
	},

    deleteCardRequest : function(customerId){
		MyWindow.alert("Voulez vous supprimer la carte bancaire enregistrée?", {
			buttons : [
				{
					text : Loc.g("Non"),
					'class': 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					'class': 'btn btn-primary',
					click : function(e){

                        $(e.currentTarget).prop('disabled',true);

                        var thirdid = $("#thirdid").val();
                        var thirdtype = $("#thirdtype").val();

						MyFacture.post("/rest/stripe/card/delete", {customerId : customerId ,thirdid : thirdid, thirdtype : thirdtype}, function(data, result){

                            if(data.result) {
                                Utils.reload();
                            } else if(data.error){
                                $('#alertWindow').dialog('close');
                                Push.error(window.i18n.gettext("Une erreur s'est produite"));
                            }

                        }, 'json', undefined, false);

					}
				}
			]
		});
	},

	switchFilterCampaign : function(listingName) {
		if ($('#' + listingName + '_filter_campaignSearch').val() == 'nothing') {
			$('.campaignType').addClass('hidden');
			$('.campaignSubscription').addClass('hidden');
			$('.campaignPeriod').addClass('hidden');
		} else {
			$('.campaignType').removeClass('hidden');
			$('.campaignSubscription').removeClass('hidden');
			$('.campaignPeriod').removeClass('hidden');
		}

		if ($('#' + listingName + '_filter_campaignSearch').val() == 'history') {
			$('.campaignPeriod').removeClass('hidden');
		} else {
			$('.campaignPeriod').addClass('hidden');
		}
	},

    exportRegister: function (linkedtype, linkedid) {

        var options = {
            type      : 'warning',
            resizable : false,
            noclose   : true,
            width     : 500,
            title: Loc.g("Confirmation de l‘envoi de la liste de traitement"),
            buttons   : [
                { text: Loc.g("Non"), click: function () { $(this).dialog("close"); } },
                {
                    text:
                        Loc.g("Oui"),
                    click: _.debounce(function () {
                        var data = {
                            action: "exportRegister",
                            linkedid: linkedid,
                            linkedtype: linkedtype,
                        };
                        MyFacture.post(
                            "people",
                            data,
                            function (data) {
                                $('#alertWindow').dialog('close');
                                Utils.reload();
                            },
                            "json"
                        );
                    }, 500)
                }
            ]
        };

        MyWindow.alert(Loc.g("Souhaitez vous recevoir par email l’historique des traitements de cette fiche ?"), options);
    }
};

var suppliersForm = {

    prepareForm: function(){
        var formId = "thirdForm";
        var options = {success:function(data){Third.processForm(data);}, dataType:"json"};
		var data = {action:'record'};
        MyForm.prepare("thirdForm", "suppliersForm&"+$.param(data), options);
    }

};

window.BankAccount = {

	edit : function(baid, linkedtype, linkedid){
		var formID = "bankAccountForm";
		var title = Loc.g('Modifier un RIB');

		if(baid === undefined || baid === ''){
			title = Loc.g("Ajouter un compte bancaire");
			baid = '';
		}

		var options = {
            title	: title,
            dialogClass: "white",
			buttons	: [
				{text : Loc.g('Annuler'),		click : function(){$(this).dialog("close");}},
                {text : Loc.g("Enregistrer"), 	click : function(){$("#"+formID).submit();}}
			],
			callback	: function(){
				var options = {
					success: function(data){
						var formIsOk = MyForm.processJson(data, formID);
						if(formIsOk){
							Utils.reload();
//							MyWindow.close();
						}
					},
					dataType: "json",
					data : {
						baid		: baid,
						linkedid	: linkedid,
						linkedtype	: linkedtype,
						action		: "bankAccountRecord"
					}
				};

				$('.hasIban').change(function(){
					$(this).closest('form').find('.data-group').hide();
					$(this).closest('form').find('.hasiban-'+$(this).val()).show();
				});

				MyForm.prepare(formID, "bankaccount", options, true);
				MyFacture.initEvent();
			}
		};

		MyWindow.load("bankaccount", {action: "bankAccountForm", linkedid: linkedid, linkedtype : linkedtype, baid: baid}, options);
	},

	deleteOne : function(baid, callback){
		if(!Utils.exists("bankaccount_"+baid)){
			return;
		}

		var options = {
			type	: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'un RIB"),
			buttons		: [
				{text :
					Loc.g("Oui"),
					click : function(){
						var data = {
							action	: "bankAccountDelete",
							baid	: baid
						};
						MyFacture.post(
							"bankaccount",
							data,
							function(data){
								$('#alertWindow').dialog('close');

								if(data.baid != undefined){
									if(callback != undefined && $.isFunction(callback)){
										callback.call(data, data);
									}

									$("#bankaccount_"+data.baid).fadeOut('slow', function(){
										$(this).remove();
									});
								}

							},
							"json"
						);
					}
				},
				{text : Loc.g("Non"), click : function(){$(this).dialog("close");}}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous supprimer ce RIB ?"), options);
	}
};

window.StickyNote = {
	editableSticky: true,
	edit: function (linkedid, linkedtype) {
        if ($(".stickyContent").hasClass("sticky-note")) {
            $(".sticky-note").addClass("js-active");
        }

		if (StickyNote.editableSticky) {
			var height = ($('.stickyContent').height() < 25 ? 25 : $('.stickyContent').height());
			var stickyContent = $('.stickyContent').html();
			$('.stickyContent').html('<form>'
					+ '<input type="hidden" name="linkedid" value="' + linkedid + '" />'
					+ '<input type="hidden" name="linkedtype" value="' + linkedtype + '" />'
					+ '<textarea name="stickyContent" id="textareaStickyContent" class="redactor lightButtons mb4" style="width:100%;height:' + height + 'px;">'
					+ stickyContent
					+ '</textarea><input type="button" value="' + window.i18n.gettext('Enregistrer') + '" onclick="StickyNote.record();" class="btn btn-primary btn-small fright mt-1"/></form>');

			$('.stickyContent textarea').trigger('focus');
			StickyNote.editableSticky = false;

			MyFacture.customForm('.stickyContent');
		}

	},
	record: function () {
		var linkedid		= $('input[name=linkedid]').val();
		var linkedtype		= $('input[name=linkedtype]').val();
		var stickyContent	= $('textarea[name=stickyContent]').val();

		MyFacture.post("stickyNote",
				{action: "record", linkedid: linkedid, linkedtype: linkedtype, stickyNote: stickyContent},
		function (data) {
			if (data.err_code == 0) {
				StickyNote.editableSticky = true;
				$('.stickyContent').html(data.stickyNote);
			} else {
				MyWindow.alert(data.err_msg, {type: 'error'});
			}
            if ($(".sticky-note").hasClass("js-active")) {
                $(".sticky-note").removeClass("js-active");
            }
		},
				"json");
		$('.stickyContent').html(stickyContent);
	}
};

window.ThirdsDuplicates = {

	init: function(){
		var options = {success:function(data){ThirdsDuplicates.recordFormCallback(data);}, dataType:"json"};
		MyForm.prepare("thirdsDuplicatesForm", "thirdsDuplicates&action=getThirdsDuplicates", options, false, false);
		MyFacture.initEvent();
	},

	recordFormCallback: function(data){
		$('#thirdsDuplicatesForm .alert').hide();
		var formIsOk = MyForm.processJson(data, "thirdsDuplicatesForm");
		if(formIsOk) {
			$('#thirdsduplicates .stats-result').html(data.thirdsduplicatesarray);
			$('.tableSort').tablesorter();
			Qtip.init();
		} else {
			var errorMsg = Loc.g('Vous devez cocher au minimum un élément et un paramètre de recherche');
			if(errorMsg !== ''){
				$('#thirdsduplicates .alert').html(errorMsg).show();
			}
		}
	},

	displayThirdsDuplicates: function(elemid, datas){

		if($('#faThirdDuplicate_'+elemid).hasClass('rotated180')){
			MyFacture.customForm();
			$('#faThirdDuplicate_'+elemid).addClass('reverseRotated180');
			$('#faThirdDuplicate_'+elemid).removeClass('rotated180');
		} else{
			$('#faThirdDuplicate_'+elemid).addClass('rotated180');
			$('#faThirdDuplicate_'+elemid).removeClass('reverseRotated180');
		}

		$('#duplicatesList_'+elemid).toggle("slow");
		MyFacture.post("thirdsDuplicates",
			{action: "getDuplicatesList", elemid: elemid, datas: datas},
			function (data) {
				$('#duplicatesThirdsList_'+elemid).html(data.thirdsduplicatesarraylist);
				$('.tableSort').tablesorter();
				Qtip.init();
			},
			"json");
	},

	toggleDupliSearchCriterias: function(){
		var typeSelected = $('#thirdsdupli_type').val();

		if(typeSelected == 'third'){
			$('#thirdsDuplicatesForm .searchThird').each(function(){
				$(this).removeClass('hidden');
			});

			$('#thirdsDuplicatesForm .searchPeople').each(function(){
				$(this).addClass('hidden');
			});
		} else if(typeSelected == 'people'){
			$('#thirdsDuplicatesForm .searchThird').each(function(){
				$(this).addClass('hidden');
			});

			$('#thirdsDuplicatesForm .searchPeople').each(function(){
				$(this).removeClass('hidden');
			});
		}
	}
};


window.Thirds = {

    transformThirds: function (tothirdtype, thirdids) {
        var title = tothirdtype == 'client' ? Loc.g("Transformation des prospects en clients.") : Loc.g("Transformation des clients en prospects.")
        var options = {
            title: title,
            width: 800,
            buttons: [
                {
                    text: Loc.g("Annuler"), click: function () {
                        $(this).dialog("close");
                    }
                },
				{
                    text: Loc.g("Continuer"), click: function () {
                        $("#transformThirds").submit();
                        $(this).dialog("close");
                    }
                }
            ],
            callback: function () {
                Thirds.prepareTransformThirds('recordTransformThirds', 'transformThirds');
            }
        };

        var params = {
            action: "transformThirdsForm",
            thirdids: thirdids,
            tothirdtype: tothirdtype
        };

        MyWindow.load("thirds", params, options);
    },

    prepareTransformThirds: function (action, formId) {

        action = (action == undefined) ? 'recordTransformThirds' : action;
        formId = (formId == undefined) ? "transformThirds" : formId;

        MyFacture.customForm();

        var options = {
            success: function (data) {
                var formIsOk = MyForm.processJson(data, "groupForm");

                if (formIsOk) {
                    if (data.response){
                        Push.success(Loc.g("L‘action de transformation de client en prospect sera traitée dans quelques minutes. Vous recevrez un email avec le détail des modifications effectuées."), Loc.g('Transformation en cours'));
                        Utils.reload();
                    } else{
                        Push.error(Loc.g("Une erreur est survenue lors de la transformation. Nous vous invitons à relancer l‘action dans quelques minutes, si le problème persiste nous vous invitons à contacter notre service support."), Loc.g('Erreur lors de la transformation'));
                    }
                } else{
                    Push.error(Loc.g("Une erreur est survenue lors de la transformation. Nous vous invitons à relancer l‘action dans quelques minutes, si le problème persiste nous vous invitons à contacter notre service support."), Loc.g('Erreur lors de la transformation'));
                }

            }, dataType: "json"
        };

        MyForm.prepare(formId, "thirds&" + $.param({ action: action }), options, true);

    },
};
